
export default {
  scrollToTop: true,
  data() {
    return {
      selectedServices: [],
      calculatorLeadSource: {
        position:
          'Клик по кнопке "Подключить" калькулятор стоимости расширений',
        chapter: 'Страница "Калькулятор | Профиль Мегасреда для бизнеса"',
      },
      leadSource: {
        position: 'Форма "Поможем в выборе"',
        chapter: 'Страница "Калькулятор | Профиль Мегасреда для бизнеса"',
      },
    }
  },
  methods: {
    updateSelectedServices(services) {
      this.selectedServices = services
    },
  },
}
